import type { Maybe } from '../../types'
import React from 'react'

const DEFAULT_COLOR = 'var(--color-primary)'

export const Icon: React.FC<{
  icon: IconVariant
  className?: string
  color?: Maybe<string>
  style?: React.CSSProperties
  stroke?: boolean
  onClick?: (evt: React.MouseEvent) => void
}> = (props) => {
  const className: string = props.className || ''
  const style: React.CSSProperties = props.style || {}
  const onClick = React.useCallback(
    (evt: React.MouseEvent) => {
      props?.onClick?.(evt)
    },
    [props],
  )

  const pathStyle =
    props.color !== null
      ? {
          [props.stroke ? 'stroke' : 'fill']: props.color || DEFAULT_COLOR,
        }
      : {}

  switch (props.icon) {
    case 'main-menu-kpis':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
          width="24"
          height="24"
          className={className}
          style={style}
          onClick={onClick}
        >
          <path
            style={pathStyle}
            d="M5 9.2h3V19H5V9.2zM10.6 5h2.8v14h-2.8V5zm5.6 8H19v6h-2.8v-6z"
          />
        </svg>
      )
    case 'main-menu-filter':
      return (
        <svg
          className={className}
          style={style}
          onClick={onClick}
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M15.1398 1.20476e-06H0.874955C0.623362 -0.000474698 0.392709 0.140075 0.2777 0.363906C0.161104 0.590752 0.181568 0.863919 0.330525 1.07109L5.55655 8.43295C5.55829 8.43549 5.56019 8.43787 5.56194 8.44041C5.75182 8.69676 5.85446 9.00721 5.85509 9.32638V15.3284C5.85398 15.5063 5.92378 15.6769 6.0491 15.8031C6.17442 15.9292 6.3448 15.9999 6.52247 15.9999C6.61289 15.9999 6.7022 15.9818 6.78564 15.9473L9.72226 14.8275C9.98543 14.7472 10.1601 14.4989 10.1601 14.1999V9.32638C10.1606 9.00737 10.2634 8.69676 10.4531 8.44041C10.4548 8.43787 10.4567 8.43549 10.4585 8.43295L15.6843 1.07078C15.8333 0.86376 15.8538 0.590752 15.7372 0.363906C15.6222 0.140075 15.3915 -0.000474698 15.1398 1.20476e-06ZM9.79825 7.95927C9.50636 8.35538 9.34852 8.8343 9.34757 9.32638V14.1012L6.6673 15.1232V9.32638C6.66635 8.8343 6.50851 8.35538 6.21646 7.95927L1.14289 0.812204H14.872L9.79825 7.95927Z"
            fill="black"
          />
        </svg>
      )
    case 'main-menu-calendar':
      return (
        <svg
          className={className}
          style={style}
          onClick={onClick}
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_145_12222)">
            <path
              d="M2.41787 16H13.5823C14.7527 16 15.7038 15.0489 15.7038 13.8785V3.30665C15.7038 2.13628 14.7527 1.18516 13.5823 1.18516H12.7409V0.592581C12.7409 0.266652 12.4741 0 12.1482 0C11.8223 0 11.5556 0.266652 11.5556 0.592581V1.18516H4.44456V0.592581C4.44456 0.266652 4.17786 0 3.85193 0C3.526 0 3.25935 0.266652 3.25935 0.592581V1.18516H2.41787C1.24751 1.18516 0.296387 2.13628 0.296387 3.30665V13.8785C0.296387 15.0489 1.24751 16 2.41787 16ZM1.4816 3.30665C1.4816 2.79111 1.90233 2.37038 2.41787 2.37038H3.25935V2.96296C3.25935 3.28889 3.526 3.55554 3.85193 3.55554C4.17786 3.55554 4.44451 3.28889 4.44451 2.96296V2.37038H11.5556V2.96296C11.5556 3.28889 11.8223 3.55554 12.1482 3.55554C12.4741 3.55554 12.7408 3.28889 12.7408 2.96296V2.37038H13.5823C14.0978 2.37038 14.5185 2.79111 14.5185 3.30665V5.03704H1.4816V3.30665ZM1.4816 6.2222H14.5186V13.8785C14.5186 14.394 14.0979 14.8148 13.5824 14.8148H2.41787C1.90233 14.8148 1.4816 14.394 1.4816 13.8785V6.2222Z"
              fill="black"
            />
          </g>
          <defs>
            <clipPath id="clip0_145_12222">
              <rect width="16" height="16" fill="white" />
            </clipPath>
          </defs>
        </svg>
      )
    case 'main-menu-versions':
      return (
        <svg
          className={className}
          style={style}
          onClick={onClick}
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M14.1485 3.444L11.5517 0.847219C11.0056 0.301 10.2793 0.000125 9.50671 0H6.49371C5.67171 0 5.02081 0.667219 5.02081 1.47291V2.00831H4.48537C3.68896 2.00831 3.01246 2.65072 3.01246 3.48122V4.01662H2.47706C1.68056 4.01662 1.00415 4.65906 1.00415 5.48953V14.527C1.00415 15.3392 1.6649 15.9999 2.47706 15.9999H9.50621C10.3184 15.9999 10.9791 15.3392 10.9791 14.527V13.9916H11.5146C12.3267 13.9916 12.9875 13.3309 12.9875 12.5187V11.9833H13.5229C14.3314 11.9833 14.9958 11.3297 14.9958 10.5104V5.48959C14.9953 4.7175 14.6945 3.98991 14.1485 3.444ZM10.9791 1.60044L13.3953 4.01666H11.5145C11.2193 4.01666 10.9791 3.77647 10.9791 3.48125V1.60044H10.9791ZM10.0416 14.5271C10.0416 14.8223 9.80143 15.0625 9.50621 15.0625H2.47706C2.18184 15.0625 1.94165 14.8223 1.94165 14.5271V5.48959C1.94165 5.19016 2.18434 4.95419 2.47706 4.95419H3.01246V12.5187C3.01246 13.3493 3.6889 13.9917 4.48537 13.9917H10.0416V14.5271ZM12.05 12.5187C12.05 12.814 11.8098 13.0542 11.5146 13.0542H4.48537C4.19015 13.0542 3.94996 12.814 3.94996 12.5187V3.48125C3.94996 3.18241 4.19206 2.94584 4.48537 2.94584H5.02081V10.5104C5.02081 11.341 5.69724 11.9833 6.49371 11.9833H12.05V12.5187ZM14.0583 10.5104C14.0583 10.8022 13.8224 11.0458 13.5228 11.0458H6.49371C6.20187 11.0458 5.95831 10.8098 5.95831 10.5104V1.47291C5.95831 1.18112 6.19418 0.9375 6.49371 0.9375H9.50671C9.80218 0.9375 10.0416 1.17659 10.0416 1.47241V3.48125C10.0416 4.29341 10.7024 4.95416 11.5145 4.95416H13.5229C13.8181 4.95416 14.0583 5.19434 14.0583 5.48956V10.5104H14.0583Z"
            fill="black"
          />
          <path
            d="M11.7745 6.10365C11.5591 5.96009 11.2681 6.01828 11.1245 6.23369L9.50619 8.66116L8.89203 7.73994C8.74841 7.52453 8.45738 7.46631 8.242 7.60994C8.02656 7.75353 7.96838 8.04456 8.112 8.25997L9.11619 9.76622C9.29334 10.0423 9.71913 10.0422 9.89622 9.76622L11.9046 6.75372C12.0482 6.53831 11.99 6.24725 11.7745 6.10365Z"
            fill="black"
          />
        </svg>
      )
    case 'main-menu-generic-report':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
          width="24"
          height="24"
          className={className}
          style={style}
          onClick={onClick}
        >
          <path
            style={pathStyle}
            d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM5.5 7.5h2v-2H9v2h2V9H9v2H7.5V9h-2V7.5zM19 19H5L19 5v14zm-2-2v-1.5h-5V17h5z"
          />
        </svg>
      )
    case 'main-menu-headcount':
      return (
        <svg
          className={className}
          style={style}
          onClick={onClick}
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10.7058 8.81024C10.7058 7.65009 10.2506 6.56272 9.42413 5.74843C8.59775 4.93429 7.50264 4.49596 6.3424 4.5128C5.20406 4.52977 4.13901 4.98409 3.34348 5.79195C2.54804 6.59976 2.11 7.67171 2.11005 8.81028C2.11005 9.79942 2.45408 10.7647 3.07883 11.5284C3.18096 11.6533 3.33279 11.7249 3.4954 11.7249H9.32041C9.48298 11.7249 9.63485 11.6533 9.73707 11.5284C10.3618 10.7647 10.7058 9.79938 10.7058 8.81024ZM6.40791 8.41097C5.99992 8.41097 5.66799 8.07909 5.66799 7.6711C5.66799 7.26311 5.99992 6.93118 6.40791 6.93118C6.81589 6.93118 7.14783 7.26311 7.14783 7.6711C7.14783 8.07909 6.81589 8.41097 6.40791 8.41097ZM6.08038 9.07638C6.1857 9.10091 6.29523 9.11432 6.40791 9.11432C6.521 9.11432 6.63096 9.10081 6.73665 9.0761C6.95183 9.13354 7.14811 9.24627 7.30758 9.40574C7.54779 9.64595 7.68007 9.96532 7.68007 10.305V11.0216H5.13584V10.305C5.13584 9.72759 5.52901 9.22315 6.08038 9.07638ZM9.24182 11.0216H8.38341V10.305C8.38341 9.77748 8.17799 9.28153 7.80494 8.90842C7.7038 8.80728 7.59295 8.71843 7.47455 8.64228C7.70839 8.3857 7.85117 8.04476 7.85117 7.6711C7.85117 6.87524 7.20372 6.22783 6.40791 6.22783C5.61209 6.22783 4.96464 6.87529 4.96464 7.6711C4.96464 8.04504 5.10761 8.38617 5.34173 8.6428C4.79003 8.99855 4.43244 9.6189 4.43244 10.305V11.0216H3.57399C3.08291 10.3932 2.81339 9.61116 2.81339 8.81028C2.81339 6.82441 4.36811 5.24568 6.3529 5.2161C7.3239 5.20259 8.23942 5.56866 8.93052 6.2495C9.62182 6.93052 10.0025 7.83995 10.0025 8.81024C10.0025 9.61116 9.7329 10.3933 9.24182 11.0216Z"
            fill="black"
          />
          <path
            d="M23.0857 0.429077H0.914348C0.410191 0.429077 0 0.839268 0 1.34343V4.6815C0 4.87576 0.157455 5.03317 0.351673 5.03317C0.545889 5.03317 0.703345 4.87576 0.703345 4.6815V3.86867H23.2967V18.1229C23.2967 18.2392 23.202 18.3339 23.0857 18.3339H21.89V17.4782C21.89 17.2839 21.7326 17.1265 21.5383 17.1265C21.344 17.1265 21.1866 17.2839 21.1866 17.4782V21.9336C21.1866 21.9465 21.1761 21.9571 21.1632 21.9571H19.3396V21.2214C19.3396 20.924 19.0977 20.6821 18.8004 20.6821H15.3066C15.0093 20.6821 14.7674 20.924 14.7674 21.2214V21.9571H12.9438C12.931 21.9571 12.9204 21.9465 12.9204 21.9336V11.7487C12.9204 11.7358 12.931 11.7253 12.9438 11.7253H21.1631C21.176 11.7253 21.1866 11.7358 21.1866 11.7487V15.837C21.1866 16.0313 21.344 16.1887 21.5383 16.1887C21.7325 16.1887 21.8899 16.0313 21.8899 15.837V11.7487C21.8899 11.3479 21.5639 11.0219 21.1631 11.0219H12.9439C12.5431 11.0219 12.2171 11.3479 12.2171 11.7487V18.3339H10.4074C10.2395 17.804 9.97414 17.2961 9.61323 16.8398C9.46491 16.6524 9.18836 16.6167 8.99667 16.7605L8.68157 16.9967C8.28297 16.5993 7.79977 16.2918 7.26705 16.0998C5.2975 15.3902 3.12182 16.3913 2.37126 18.3339H0.914348C0.798015 18.3339 0.703345 18.2392 0.703345 18.1229V6.32264C0.703345 6.12837 0.545889 5.97097 0.351673 5.97097C0.157455 5.97097 0 6.12837 0 6.32264V18.1229C0 18.627 0.410191 19.0372 0.914348 19.0372H2.17259C2.02938 19.8201 2.1316 20.626 2.47699 21.3607C2.91461 22.2915 3.68848 22.9961 4.656 23.3448C5.07899 23.4972 5.51765 23.5709 5.95306 23.5709C6.94633 23.5709 7.9214 23.187 8.64786 22.4814L8.83444 22.6545C8.91987 22.7336 9.02879 22.7729 9.13748 22.7729C9.2556 22.7729 9.37339 22.7266 9.46032 22.6348C9.73927 22.3401 9.97404 22.0082 10.1581 21.6484C10.572 20.8393 10.7049 19.926 10.5715 19.0372H12.2172V21.9336C12.2172 22.3344 12.5433 22.6604 12.944 22.6604H14.9317C15.229 22.6604 15.4709 22.4185 15.4709 22.1212V21.3855H18.6365V22.1212C18.6365 22.4185 18.8784 22.6604 19.1757 22.6604H21.1634C21.5641 22.6604 21.8902 22.3344 21.8902 21.9336V19.0372H23.0858C23.59 19.0372 24.0002 18.627 24.0002 18.1229V1.34343C24 0.839268 23.5898 0.429077 23.0857 0.429077ZM4.89444 22.6831C4.1036 22.3981 3.47115 21.8222 3.11343 21.0614C2.7558 20.3006 2.71576 19.4461 3.0007 18.6552C3.58898 17.0227 5.39597 16.1733 7.02857 16.7614C7.43206 16.9069 7.80066 17.1333 8.11172 17.424L5.82013 19.1423C5.71416 19.2217 5.64941 19.3431 5.64247 19.4754C5.63553 19.6076 5.68725 19.7352 5.78436 19.8253L8.13118 22.0024C7.27756 22.8126 6.01754 23.0881 4.89444 22.6831ZM6.24237 19.7048C6.24228 19.7049 6.24219 19.705 6.24205 19.7051C6.24205 19.7051 6.24205 19.7051 6.24205 19.705L6.24237 19.7048ZM9.53183 21.3281C9.41704 21.5524 9.27862 21.7638 9.11877 21.959L6.4892 19.5197L9.21162 17.4784C10.0178 18.6388 10.1479 20.1239 9.53183 21.3281ZM0.703345 3.16532V1.34343C0.703345 1.22709 0.798015 1.13242 0.914348 1.13242H23.0857C23.202 1.13242 23.2967 1.22709 23.2967 1.34343V3.16532H0.703345Z"
            fill="black"
          />
          <path
            d="M14.6933 1.79712H2.36748C2.17326 1.79712 2.01581 1.95453 2.01581 2.14879C2.01581 2.34306 2.17326 2.50046 2.36748 2.50046H14.6934C14.8876 2.50046 15.045 2.34306 15.045 2.14879C15.045 1.95453 14.8876 1.79712 14.6933 1.79712Z"
            fill="black"
          />
          <path
            d="M21.6325 1.79712H21.4735C21.2792 1.79712 21.1218 1.95453 21.1218 2.14879C21.1218 2.34306 21.2792 2.50046 21.4735 2.50046H21.6325C21.8268 2.50046 21.9842 2.34306 21.9842 2.14879C21.9842 1.95453 21.8268 1.79712 21.6325 1.79712Z"
            fill="black"
          />
          <path
            d="M20.3012 1.79712H20.1422C19.9479 1.79712 19.7905 1.95453 19.7905 2.14879C19.7905 2.34306 19.9479 2.50046 20.1422 2.50046H20.3012C20.4955 2.50046 20.6529 2.34306 20.6529 2.14879C20.6529 1.95453 20.4955 1.79712 20.3012 1.79712Z"
            fill="black"
          />
          <path
            d="M18.97 1.79712H18.811C18.6167 1.79712 18.4593 1.95453 18.4593 2.14879C18.4593 2.34306 18.6167 2.50046 18.811 2.50046H18.97C19.1642 2.50046 19.3216 2.34306 19.3216 2.14879C19.3216 1.95453 19.1642 1.79712 18.97 1.79712Z"
            fill="black"
          />
          <path
            d="M9.19279 12.5938H3.62309C3.32577 12.5938 3.08386 12.8357 3.08386 13.133V14.6844C3.08386 14.9818 3.32577 15.2237 3.62309 15.2237H9.19279C9.49011 15.2237 9.73202 14.9818 9.73202 14.6844V13.133C9.73202 12.8357 9.49011 12.5938 9.19279 12.5938ZM9.02867 14.5203H3.78721V13.2971H9.02867V14.5203Z"
            fill="black"
          />
          <path
            d="M19.78 13.1763C19.78 12.879 19.5381 12.6371 19.2407 12.6371H14.8664C14.5691 12.6371 14.3272 12.879 14.3272 13.1763V14.581C14.3272 14.8784 14.5691 15.1203 14.8664 15.1203H19.2407C19.5381 15.1203 19.78 14.8784 19.78 14.581V13.1763ZM19.0766 14.4169H15.0306V13.3405H19.0766V14.4169Z"
            fill="black"
          />
          <path
            d="M15.3476 16.0858H14.6789C14.4846 16.0858 14.3272 16.2433 14.3272 16.4375C14.3272 16.6318 14.4846 16.7892 14.6789 16.7892H15.3476C15.5418 16.7892 15.6992 16.6318 15.6992 16.4375C15.6992 16.2433 15.5418 16.0858 15.3476 16.0858Z"
            fill="black"
          />
          <path
            d="M19.4282 16.0858H16.6315C16.4373 16.0858 16.2798 16.2433 16.2798 16.4375C16.2798 16.6318 16.4373 16.7892 16.6315 16.7892H19.4282C19.6225 16.7892 19.7799 16.6318 19.7799 16.4375C19.7799 16.2433 19.6225 16.0858 19.4282 16.0858Z"
            fill="black"
          />
          <path
            d="M15.3476 17.5863H14.6789C14.4846 17.5863 14.3272 17.7437 14.3272 17.938C14.3272 18.1323 14.4846 18.2897 14.6789 18.2897H15.3476C15.5418 18.2897 15.6992 18.1323 15.6992 17.938C15.6992 17.7437 15.5418 17.5863 15.3476 17.5863Z"
            fill="black"
          />
          <path
            d="M19.4282 17.5863H16.6315C16.4373 17.5863 16.2798 17.7437 16.2798 17.938C16.2798 18.1323 16.4373 18.2897 16.6315 18.2897H19.4282C19.6225 18.2897 19.7799 18.1323 19.7799 17.938C19.7799 17.7437 19.6225 17.5863 19.4282 17.5863Z"
            fill="black"
          />
          <path
            d="M15.3476 19.0868H14.6789C14.4846 19.0868 14.3272 19.2442 14.3272 19.4385C14.3272 19.6327 14.4846 19.7901 14.6789 19.7901H15.3476C15.5418 19.7901 15.6992 19.6327 15.6992 19.4385C15.6992 19.2442 15.5418 19.0868 15.3476 19.0868Z"
            fill="black"
          />
          <path
            d="M19.4282 19.0868H16.6315C16.4373 19.0868 16.2798 19.2442 16.2798 19.4385C16.2798 19.6327 16.4373 19.7901 16.6315 19.7901H19.4282C19.6225 19.7901 19.7799 19.6327 19.7799 19.4385C19.7799 19.2442 19.6225 19.0868 19.4282 19.0868Z"
            fill="black"
          />
          <path
            d="M13.3517 4.51233C13.1574 4.51233 13 4.66974 13 4.864V9.63944C13 9.88505 13.1998 10.0849 13.4455 10.0849H20.1422C20.3365 10.0849 20.4939 9.92748 20.4939 9.73322C20.4939 9.53895 20.3365 9.38154 20.1422 9.38154H13.7033V7.88365L15.5003 6.57566C15.6563 6.67662 15.8416 6.73593 16.0408 6.73593C16.1668 6.73593 16.287 6.7115 16.3981 6.66865L16.9528 7.28337C16.8776 7.42357 16.8347 7.58361 16.8347 7.75358C16.8347 8.30388 17.2824 8.75163 17.8327 8.75163C18.3831 8.75163 18.8308 8.30388 18.8308 7.75358C18.8308 7.65366 18.8157 7.5573 18.7882 7.46624L19.6865 6.76252C19.8331 6.8473 20.0027 6.89658 20.1839 6.89658C20.7342 6.89658 21.1819 6.44883 21.1819 5.89853C21.1819 5.34823 20.7342 4.90048 20.1839 4.90048C19.6336 4.90048 19.1858 5.34823 19.1858 5.89853C19.1858 6.01078 19.2053 6.11835 19.2396 6.21911L18.3604 6.90797C18.2071 6.81199 18.0266 6.75553 17.8327 6.75553C17.7093 6.75553 17.5915 6.77912 17.4822 6.82029L16.9238 6.20148C16.9969 6.06278 17.0388 5.90519 17.0388 5.73779C17.0388 5.18749 16.591 4.73974 16.0407 4.73974C15.4904 4.73974 15.0427 5.18749 15.0427 5.73779C15.0427 5.83246 15.0568 5.92371 15.0815 6.0105L13.7033 7.01371V4.864C13.7033 4.66974 13.5459 4.51233 13.3517 4.51233ZM20.1839 5.60373C20.3464 5.60373 20.4786 5.73592 20.4786 5.89844C20.4786 6.06096 20.3464 6.19314 20.1839 6.19314C20.0214 6.19314 19.8892 6.06096 19.8892 5.89844C19.8892 5.73592 20.0214 5.60373 20.1839 5.60373ZM18.1276 7.75353C18.1276 7.91605 17.9953 8.04824 17.8328 8.04824C17.6703 8.04824 17.5381 7.91605 17.5381 7.75353C17.5381 7.59101 17.6703 7.45883 17.8328 7.45883C17.9953 7.45883 18.1276 7.59101 18.1276 7.75353ZM16.0408 5.44309C16.2034 5.44309 16.3355 5.57527 16.3355 5.73779C16.3355 5.90031 16.2034 6.03254 16.0408 6.03254C15.8783 6.03254 15.7461 5.90031 15.7461 5.73779C15.7461 5.57527 15.8783 5.44309 16.0408 5.44309Z"
            fill="black"
          />
        </svg>
      )
    case 'main-menu-planning':
      return (
        <svg
          className={className}
          style={style}
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g>
            <path
              d="M3.68227 8.93246C3.62071 8.93243 3.56011 8.91724 3.50581 8.88824C3.45152 8.85923 3.40521 8.8173 3.37096 8.76615C3.33672 8.71499 3.3156 8.65619 3.30948 8.59494C3.30335 8.53369 3.31241 8.47188 3.33584 8.41496C4.02181 6.75496 5.17188 5.32797 6.64822 4.30496C6.6885 4.27475 6.73445 4.25297 6.78333 4.24091C6.83221 4.22884 6.88302 4.22674 6.93273 4.23474C6.98244 4.24273 7.03003 4.26065 7.07266 4.28743C7.11529 4.31421 7.1521 4.3493 7.18088 4.39061C7.20966 4.43192 7.22983 4.4786 7.24018 4.52787C7.25053 4.57715 7.25085 4.628 7.24113 4.6774C7.23141 4.72679 7.21184 4.77373 7.18359 4.8154C7.15534 4.85708 7.11898 4.89263 7.0767 4.91996C5.71863 5.86103 4.66054 7.17354 4.02907 8.70037C4.00075 8.76906 3.95267 8.82779 3.89093 8.86911C3.82919 8.91043 3.75656 8.93248 3.68227 8.93246Z"
              fill="black"
            />
            <path
              d="M8.25 4.125C8.45711 4.125 8.625 3.95711 8.625 3.75C8.625 3.54289 8.45711 3.375 8.25 3.375C8.04289 3.375 7.875 3.54289 7.875 3.75C7.875 3.95711 8.04289 4.125 8.25 4.125Z"
              fill="black"
            />
            <path
              d="M12.5 11.4286H11.5C11.3674 11.4286 11.2402 11.3684 11.1464 11.2612C11.0527 11.154 11 11.0087 11 10.8571C11 10.7056 11.0527 10.5602 11.1464 10.4531C11.2402 10.3459 11.3674 10.2857 11.5 10.2857H13.5C13.6326 10.2857 13.7598 10.2255 13.8536 10.1183C13.9473 10.0112 14 9.86584 14 9.71429C14 9.56273 13.9473 9.41739 13.8536 9.31022C13.7598 9.20306 13.6326 9.14286 13.5 9.14286H12.5V8.57143C12.5 8.41988 12.4473 8.27453 12.3536 8.16737C12.2598 8.0602 12.1326 8 12 8C11.8674 8 11.7402 8.0602 11.6464 8.16737C11.5527 8.27453 11.5 8.41988 11.5 8.57143V9.14286C11.1022 9.14286 10.7206 9.32347 10.4393 9.64496C10.158 9.96645 10 10.4025 10 10.8571C10 11.3118 10.158 11.7478 10.4393 12.0693C10.7206 12.3908 11.1022 12.5714 11.5 12.5714H12.5C12.6326 12.5714 12.7598 12.6316 12.8536 12.7388C12.9473 12.846 13 12.9913 13 13.1429C13 13.2944 12.9473 13.4398 12.8536 13.5469C12.7598 13.6541 12.6326 13.7143 12.5 13.7143H10.5C10.3674 13.7143 10.2402 13.7745 10.1464 13.8817C10.0527 13.9888 10 14.1342 10 14.2857C10 14.4373 10.0527 14.5826 10.1464 14.6898C10.2402 14.7969 10.3674 14.8571 10.5 14.8571H11.5V15.4286C11.5 15.5801 11.5527 15.7255 11.6464 15.8326C11.7402 15.9398 11.8674 16 12 16C12.1326 16 12.2598 15.9398 12.3536 15.8326C12.4473 15.7255 12.5 15.5801 12.5 15.4286V14.8571C12.8978 14.8571 13.2794 14.6765 13.5607 14.355C13.842 14.0335 14 13.5975 14 13.1429C14 12.6882 13.842 12.2522 13.5607 11.9307C13.2794 11.6092 12.8978 11.4286 12.5 11.4286Z"
              fill="black"
            />
            <path
              d="M12 17.625C10.8875 17.625 9.79995 17.2951 8.87492 16.677C7.94989 16.0589 7.22892 15.1804 6.80318 14.1526C6.37744 13.1248 6.26604 11.9938 6.48309 10.9026C6.70013 9.81148 7.23586 8.8092 8.02253 8.02253C8.8092 7.23586 9.81148 6.70013 10.9026 6.48309C11.9938 6.26604 13.1248 6.37744 14.1526 6.80318C15.1804 7.22892 16.0589 7.94989 16.677 8.87492C17.2951 9.79995 17.625 10.8875 17.625 12C17.6233 13.4913 17.0302 14.9211 15.9756 15.9756C14.9211 17.0302 13.4913 17.6233 12 17.625ZM12 7.125C11.0358 7.125 10.0933 7.41092 9.2916 7.94659C8.48991 8.48226 7.86507 9.24363 7.49609 10.1344C7.12711 11.0252 7.03057 12.0054 7.21867 12.9511C7.40678 13.8967 7.87108 14.7654 8.55286 15.4471C9.23464 16.1289 10.1033 16.5932 11.0489 16.7813C11.9946 16.9694 12.9748 16.8729 13.8656 16.5039C14.7564 16.1349 15.5177 15.5101 16.0534 14.7084C16.5891 13.9067 16.875 12.9642 16.875 12C16.8735 10.7075 16.3595 9.46839 15.4455 8.55447C14.5316 7.64054 13.2925 7.12646 12 7.125Z"
              fill="black"
            />
            <path
              d="M3.82497 18.96C3.81837 18.96 3.81177 18.96 3.8052 18.9596C3.7527 18.9568 3.70136 18.943 3.65452 18.9191C3.60768 18.8952 3.56638 18.8617 3.53329 18.8209C2.30764 17.3008 1.51399 15.4787 1.23572 13.5461C0.957456 11.6134 1.20484 9.64141 1.95188 7.83735C2.69893 6.03329 3.91806 4.46373 5.4812 3.29355C7.04433 2.12337 8.89377 1.39578 10.8352 1.18721C10.8875 1.18158 10.9404 1.18702 10.9905 1.20319C11.0405 1.21936 11.0866 1.24589 11.1258 1.28105C11.1649 1.31622 11.1962 1.35922 11.2176 1.40728C11.239 1.45534 11.25 1.50736 11.25 1.55996V4.58247C11.25 4.67226 11.2178 4.75908 11.1592 4.82715C11.1006 4.89522 11.0196 4.94004 10.9308 4.95345C9.24893 5.21729 7.7159 6.07125 6.60628 7.3624C5.49666 8.65354 4.88291 10.2975 4.87497 12C4.8714 13.5211 5.35859 15.0028 6.26419 16.2249C6.31748 16.2972 6.34308 16.3861 6.33636 16.4756C6.32964 16.5652 6.29103 16.6493 6.22755 16.7127L4.09005 18.85C4.05529 18.8848 4.01397 18.9125 3.96848 18.9314C3.92299 18.9503 3.87422 18.96 3.82497 18.96ZM10.5 1.98555C8.77229 2.244 7.14089 2.94516 5.76445 4.02084C4.38801 5.09652 3.31336 6.5101 2.64503 8.1241C1.9767 9.73811 1.73743 11.4976 1.9505 13.2315C2.16357 14.9653 2.82171 16.6145 3.86093 18.0187L5.47373 16.4059C4.5911 15.1064 4.12104 13.5709 4.12497 12C4.13398 10.1738 4.77332 8.40676 5.93492 6.99761C7.09651 5.58846 8.70907 4.62366 10.5 4.26634V1.98555Z"
              fill="black"
            />
            <path
              d="M22.44 11.25H19.4175C19.3277 11.25 19.241 11.2178 19.1729 11.1593C19.1049 11.1007 19.0601 11.0197 19.0467 10.931C18.8238 9.42494 18.1223 8.03055 17.0457 6.95399C15.9692 5.87744 14.5748 5.17586 13.0687 4.95298C12.9801 4.93959 12.8991 4.89484 12.8406 4.82686C12.7822 4.75887 12.75 4.67216 12.75 4.58248V1.55998C12.75 1.50739 12.7611 1.4554 12.7826 1.40738C12.804 1.35936 12.8353 1.31637 12.8744 1.28122C12.9135 1.24607 12.9595 1.21953 13.0096 1.20332C13.0596 1.18711 13.1125 1.18161 13.1647 1.18715C15.6299 1.45988 17.9286 2.56405 19.6823 4.3178C21.4361 6.07155 22.5402 8.37029 22.8129 10.8354C22.8185 10.8877 22.813 10.9406 22.7968 10.9906C22.7805 11.0406 22.754 11.0867 22.7188 11.1258C22.6837 11.1649 22.6407 11.1961 22.5926 11.2175C22.5446 11.2389 22.4926 11.25 22.44 11.25ZM19.7335 10.5H22.0143C21.6869 8.35906 20.6844 6.37863 19.1529 4.84719C17.6214 3.31575 15.6409 2.31332 13.5 1.98594V4.26635C15.0446 4.55989 16.4651 5.31139 17.5768 6.42313C18.6885 7.53487 19.44 8.9554 19.7335 10.5H19.7335Z"
              fill="black"
            />
            <path
              d="M12 22.875C9.51836 22.8733 7.1118 22.0234 5.17935 20.4664C5.13845 20.4334 5.10496 20.3921 5.08105 20.3453C5.05714 20.2985 5.04334 20.2472 5.04056 20.1947C5.03778 20.1422 5.04608 20.0897 5.06491 20.0406C5.08375 19.9915 5.11269 19.947 5.14988 19.9098L7.28738 17.7723C7.35093 17.709 7.43503 17.6705 7.5245 17.6637C7.61397 17.657 7.70288 17.6825 7.77518 17.7357C8.9972 18.6415 10.4789 19.1287 12 19.125C13.7025 19.1171 15.3465 18.5034 16.6377 17.3938C17.9289 16.2842 18.7829 14.7512 19.0469 13.0694C19.0602 12.9806 19.1049 12.8995 19.1729 12.8409C19.241 12.7823 19.3278 12.75 19.4175 12.75H22.44C22.4927 12.75 22.5447 12.761 22.5928 12.7824C22.6408 12.8038 22.6839 12.8351 22.719 12.8743C22.7542 12.9134 22.7807 12.9595 22.7969 13.0096C22.8131 13.0597 22.8185 13.1126 22.8129 13.1649C22.5311 15.8343 21.2697 18.3045 19.2725 20.098C17.2754 21.8914 14.6843 22.8809 12 22.875ZM5.98129 20.139C7.38546 21.1782 9.03466 21.8363 10.7685 22.0494C12.5023 22.2624 14.2618 22.0231 15.8758 21.3548C17.4898 20.6865 18.9033 19.6118 19.979 18.2354C21.0546 16.859 21.7558 15.2276 22.0143 13.5H19.7335C19.3763 15.2909 18.4115 16.9035 17.0024 18.0651C15.5932 19.2267 13.8262 19.866 12 19.875C10.4291 19.8789 8.89357 19.4087 7.59416 18.5259L5.98129 20.139Z"
              fill="black"
            />
          </g>
        </svg>
      )
    case 'main-menu-scenario-versions':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
          width="24"
          height="24"
          className={className}
          style={style}
          onClick={onClick}
        >
          <path
            style={pathStyle}
            d="M16.5 13c-1.2 0-3.07.34-4.5 1-1.43-.67-3.3-1-4.5-1C5.33 13 1 14.08 1 16.25V19h22v-2.75c0-2.17-4.33-3.25-6.5-3.25zm-4 4.5h-10v-1.25c0-.54 2.56-1.75 5-1.75s5 1.21 5 1.75v1.25zm9 0H14v-1.25c0-.46-.2-.86-.52-1.22.88-.3 1.96-.53 3.02-.53 2.44 0 5 1.21 5 1.75v1.25zM7.5 12c1.93 0 3.5-1.57 3.5-3.5S9.43 5 7.5 5 4 6.57 4 8.5 5.57 12 7.5 12zm0-5.5c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm9 5.5c1.93 0 3.5-1.57 3.5-3.5S18.43 5 16.5 5 13 6.57 13 8.5s1.57 3.5 3.5 3.5zm0-5.5c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2z"
          />
        </svg>
      )
    case 'main-menu-settings':
      return (
        <svg
          className={className}
          style={style}
          onClick={onClick}
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M23.6349 15.5058L23.0151 15.096L22.4014 13.6138L22.5501 12.8853C22.604 12.6222 22.5221 12.3496 22.3322 12.1597L21.4411 11.2681C21.2511 11.0786 20.9787 10.9971 20.7158 11.051L19.9873 11.1997L18.5052 10.5859L18.095 9.96621C17.9471 9.74175 17.6964 9.60656 17.4276 9.60637H16.1682C15.8993 9.60642 15.6484 9.74161 15.5005 9.96621L15.0907 10.5859L14.0652 11.0109C13.3737 9.57703 12.2416 8.40187 10.8346 7.65724C12.4783 5.8131 12.371 2.99981 10.5917 1.28619C8.81244 -0.427435 5.99706 -0.428912 4.21603 1.28286C2.435 2.99462 2.32478 5.80781 3.96647 7.65367C1.52913 8.92914 0.00275453 11.4535 0.00537446 14.2043V15.2039C0.00537446 16.7264 6.16703 16.8032 7.40211 16.8032C8.14936 16.8032 8.88385 16.7776 9.60114 16.7364V17.4329C9.60118 17.7018 9.73637 17.9527 9.96097 18.1006L10.5807 18.5104L11.1944 19.9925L11.0457 20.7214C10.9919 20.9845 11.0737 21.2572 11.2636 21.4471L12.1548 22.3387C12.3448 22.5282 12.6172 22.6097 12.8801 22.5558L13.6086 22.4071L15.0908 23.0204L15.501 23.6401C15.6488 23.8646 15.8995 23.9998 16.1683 24H17.4277C17.6966 23.9999 17.9475 23.8647 18.0954 23.6401L18.5052 23.0204L19.9874 22.4067L20.7158 22.5554C20.979 22.6092 21.2516 22.5274 21.4415 22.3375L22.3331 21.4463C22.5226 21.2563 22.6041 20.9839 22.5502 20.721L22.4015 19.9925L23.0152 18.5104L23.635 18.1002C23.8594 17.9524 23.9946 17.7017 23.9948 17.4329V16.1734C23.9947 15.9045 23.8595 15.6537 23.6349 15.5058ZM7.40211 0.810315C9.49986 0.810315 11.2004 2.51089 11.2004 4.60864C11.2004 6.7064 9.49986 8.40697 7.40211 8.40697C5.30435 8.40697 3.60378 6.7064 3.60378 4.60864C3.60621 2.51189 5.30535 0.812745 7.40211 0.810315ZM3.60378 15.8092V13.2048C3.60378 12.9839 3.42477 12.805 3.20398 12.805C2.98319 12.805 2.80418 12.984 2.80418 13.2048V15.7017C1.64469 15.5221 0.972177 15.3019 0.805073 15.1419V14.2043C0.803596 11.6498 2.27952 9.32499 4.59178 8.23934C6.243 9.52763 8.55888 9.52763 10.2101 8.23934C11.5017 8.85021 12.5622 9.8607 13.2347 11.1213L12.8801 11.0489C12.617 10.9951 12.3443 11.0769 12.1544 11.2668L11.2628 12.158C11.0733 12.348 10.9918 12.6204 11.0457 12.8833L11.1944 13.6118L10.5807 15.0959L9.96097 15.5061C9.80921 15.6079 9.69707 15.7588 9.64353 15.9336C8.91424 15.9771 8.16418 16.0035 7.40454 16.0035C6.13492 16.0104 4.86601 15.9455 3.60378 15.8092ZM23.1951 17.4329L22.4722 17.9103C22.4056 17.9543 22.3537 18.0173 22.3231 18.091L21.6158 19.7995C21.5852 19.8732 21.5775 19.9544 21.5934 20.0325L21.767 20.8814L20.8761 21.7722L20.0277 21.5986C19.9495 21.5824 19.8683 21.5902 19.7946 21.621L18.0862 22.3283C18.0124 22.3589 17.9495 22.4108 17.9055 22.4775L17.4277 23.2003H16.1683L15.6909 22.4775C15.6468 22.4108 15.5839 22.3589 15.5101 22.3283L13.8017 21.621C13.7532 21.6008 13.7011 21.5905 13.6486 21.5906C13.6217 21.5905 13.5949 21.5932 13.5686 21.5986L12.7198 21.7722L11.8289 20.8814L12.0025 20.0329C12.0184 19.9548 12.0106 19.8735 11.9801 19.7999L11.2728 18.0914C11.2423 18.0176 11.1903 17.9547 11.1237 17.9107L10.4008 17.4329V16.1735L11.1237 15.6961C11.1903 15.6521 11.2422 15.5891 11.2728 15.5154L11.9801 13.8069C12.0107 13.7332 12.0184 13.652 12.0025 13.5739L11.8289 12.725L12.7198 11.8342L13.5682 12.0078C13.6464 12.0234 13.7275 12.0156 13.8013 11.9854L15.5097 11.2781C15.5835 11.2475 15.6464 11.1956 15.6904 11.1289L16.1682 10.4061H17.4276L17.905 11.1289C17.949 11.1956 18.012 11.2475 18.0858 11.2781L19.7942 11.9854C19.8678 12.0162 19.9491 12.024 20.0273 12.0078L20.8761 11.8342L21.7669 12.725L21.5934 13.5735C21.5774 13.6517 21.5852 13.7329 21.6158 13.8065L22.323 15.515C22.3536 15.5888 22.4056 15.6517 22.4722 15.6957L23.1951 16.1735V17.4329H23.1951Z"
            fill="black"
          />
          <path
            d="M16.7979 12.405C14.369 12.405 12.3999 14.3741 12.3999 16.8031C12.3999 19.2321 14.369 21.2012 16.7979 21.2012C19.2269 21.2012 21.196 19.2321 21.196 16.8031C21.1931 14.3753 19.2258 12.4079 16.7979 12.405ZM16.7979 20.4015C14.8106 20.4015 13.1996 18.7904 13.1996 16.8031C13.1996 14.8157 14.8106 13.2047 16.7979 13.2047C18.7853 13.2047 20.3963 14.8157 20.3963 16.8031C20.3942 18.7895 18.7844 20.3993 16.7979 20.4015Z"
            fill="black"
          />
        </svg>
      )
    case 'main-menu-analytics':
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={className}
          style={style}
          onClick={onClick}
        >
          <path
            d="M20.4534 1.96406V0.72187C20.4534 0.32526 20.1307 0.00261938 19.7341 0.00261938H17.7664C17.5171 0.00261938 17.2968 0.128526 17.1652 0.319963C13.9682 -0.539537 10.57 0.358588 8.22348 2.70511C4.70186 6.22673 4.61828 11.8943 7.97701 15.5169L7.27656 16.1989L6.85605 15.7784C6.49984 15.4222 5.92 15.4222 5.5638 15.7784C4.36216 16.98 1.47583 19.8663 0.40408 20.9381C-0.127857 21.47 -0.127857 22.3355 0.40408 22.8675L1.15464 23.618C1.66413 24.1275 2.49302 24.1275 3.00255 23.618C3.11341 23.5072 7.72731 18.8933 8.20295 18.4176C8.55916 18.0613 8.55911 17.4816 8.20295 17.1254L7.77358 16.696L8.4738 16.0143C10.0163 17.4448 12.0058 18.3081 14.1147 18.454C14.123 18.4546 14.1312 18.4549 14.1393 18.4549C14.3224 18.4549 14.4767 18.3131 14.4896 18.1277C14.5029 17.9341 14.3569 17.7663 14.1632 17.7529C9.77743 17.4494 6.22389 13.8214 6.22389 9.23963C6.22389 3.58584 11.6004 -0.485959 17.037 1.01343V1.91704C12.0892 0.378229 7.08114 4.1024 7.08114 9.24938C7.08114 13.4691 10.5056 16.9262 14.758 16.9262C18.3752 16.9262 20.2846 14.5369 20.3578 14.5003C20.3578 14.5003 20.3589 14.4991 20.3588 14.4991C20.3615 14.4963 20.3641 14.4934 20.3667 14.4904C21.7005 13.0637 22.4348 11.203 22.4348 9.24938C22.4348 7.33852 21.7322 5.51644 20.4534 4.10259V2.87864C22.2465 4.48326 23.2921 6.76041 23.2921 9.23949C23.2921 13.6009 20.0382 17.2242 15.739 17.7171C15.5462 17.7392 15.4079 17.9134 15.4299 18.1063C15.452 18.2992 15.626 18.4376 15.8191 18.4155C20.4703 17.8822 23.9949 13.9626 23.9949 9.23958C23.9948 6.3547 22.6858 3.71358 20.4534 1.96406ZM2.50549 23.1209C2.27013 23.3563 1.88711 23.3563 1.6517 23.1209L0.901142 22.3704C0.643236 22.1124 0.643236 21.6929 0.901142 21.435L3.60869 18.7274L5.25381 20.3725L2.50549 23.1209ZM5.75083 19.8756L4.1057 18.2305L4.60328 17.7329L6.24841 19.378L5.75083 19.8756ZM7.70594 17.9205L6.74547 18.881L5.10034 17.2359L6.06091 16.2753C6.14237 16.1938 6.27761 16.1939 6.35908 16.2753L7.70603 17.6223C7.78745 17.7039 7.78745 17.839 7.70594 17.9205ZM11.6098 15.4712C10.849 15.0847 10.168 14.5629 9.59912 13.9374V8.72709C9.59912 8.71233 9.61112 8.70033 9.62584 8.70033H11.6099V15.4712H11.6098ZM14.3234 16.2089C13.6345 16.1667 12.9619 16.024 12.3127 15.7804C12.3127 15.702 12.3127 6.18905 12.3127 6.06206C12.3127 6.04734 12.3247 6.03534 12.3393 6.03534H14.3234V16.2089ZM14.3234 3.39712V5.3325H12.3393C11.9371 5.3325 11.6099 5.65978 11.6099 6.06206V7.99744H9.62584C9.22351 7.99744 8.89628 8.32472 8.89628 8.72705V13.0238C5.91175 8.40497 9.24704 2.2754 14.7579 2.2754C15.54 2.2754 16.3054 2.40403 17.037 2.65715V2.66751H15.053C14.6506 2.66751 14.3234 2.99484 14.3234 3.39712ZM17.037 15.8416C16.3744 16.0709 15.6923 16.1939 15.0263 16.2181V3.39717C15.0263 3.38245 15.0383 3.37045 15.053 3.37045H17.037V15.8416H17.037ZM21.7318 9.24938C21.7318 10.7048 21.283 12.1033 20.4534 13.2742V10.0386C20.4534 9.84446 20.296 9.68714 20.1019 9.68714C19.9078 9.68714 19.7505 9.8445 19.7505 10.0386V14.1175C19.1687 14.7146 18.4803 15.2027 17.7399 15.5543C17.7399 14.7542 17.7399 1.40217 17.7399 0.749854V0.732182C17.7399 0.717464 17.7518 0.705464 17.7664 0.705464H19.7341C19.7431 0.705464 19.7506 0.712823 19.7506 0.72187C19.7506 1.26154 19.7506 8.10014 19.7506 8.39859C19.7506 8.59266 19.9079 8.75002 20.102 8.75002C20.2961 8.75002 20.4534 8.59266 20.4534 8.39859V5.22455C21.2829 6.39548 21.7318 7.794 21.7318 9.24938Z"
            fill="black"
          />
        </svg>
      )
    case 'main-menu-business-optimization':
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          className={className}
          style={style}
          onClick={onClick}
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            fill="black"
            d="M0 0h1v15h15v1H0V0Zm10 3.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-1 0V4.9l-3.613 4.417a.5.5 0 0 1-.74.037L7.06 6.767l-3.656 5.027a.5.5 0 0 1-.808-.588l4-5.5a.5.5 0 0 1 .758-.06l2.609 2.61L13.445 4H10.5a.5.5 0 0 1-.5-.5Z"
          />
        </svg>
      )
    case 'main-menu-logout':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
          viewBox="0 0 24 24"
          width="24"
          height="24"
          className={className}
          style={style}
          onClick={onClick}
        >
          <path
            style={pathStyle}
            d="m17 7-1.41 1.41L18.17 11H8v2h10.17l-2.58 2.58L17 17l5-5zM4 5h8V3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8v-2H4V5z"
          />
        </svg>
      )
    case 'magnify-plus':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
          viewBox="0 0 24 24"
          width="24"
          height="24"
          className={className}
          style={style}
          onClick={onClick}
        >
          <path
            style={pathStyle}
            d="M15.5,14L20.5,19L19,20.5L14,15.5V14.71L13.73,14.43C12.59,15.41 11.11,16 9.5,16A6.5,6.5 0 0,1 3,9.5A6.5,6.5 0 0,1 9.5,3A6.5,6.5 0 0,1 16,9.5C16,11.11 15.41,12.59 14.43,13.73L14.71,14H15.5M9.5,14C12,14 14,12 14,9.5C14,7 12,5 9.5,5C7,5 5,7 5,9.5C5,12 7,14 9.5,14M12,10H10V12H9V10H7V9H9V7H10V9H12V10Z"
          />
        </svg>
      )
    case 'magnify-minus':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
          viewBox="0 0 24 24"
          width="24"
          height="24"
          className={className}
          style={style}
          onClick={onClick}
        >
          <path
            style={pathStyle}
            d="M15.5,14H14.71L14.43,13.73C15.41,12.59 16,11.11 16,9.5A6.5,6.5 0 0,0 9.5,3A6.5,6.5 0 0,0 3,9.5A6.5,6.5 0 0,0 9.5,16C11.11,16 12.59,15.41 13.73,14.43L14,14.71V15.5L19,20.5L20.5,19L15.5,14M9.5,14C7,14 5,12 5,9.5C5,7 7,5 9.5,5C12,5 14,7 14,9.5C14,12 12,14 9.5,14M7,9H12V10H7V9Z"
          />
        </svg>
      )
    case 'trashcan':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
          viewBox="0 0 20 20"
          fill="none"
          width="20"
          height="20"
          className={className}
          style={style}
          onClick={onClick}
        >
          <path
            d="M4 5.6H15.7M7.25 5.6V4.3A1.3 1.3 0 0 1 8.55 3h2.6a1.3 1.3 0 0 1 1.3 1.3v1.3m1.95 0v9.1a1.3 1.3 0 0 1-1.3 1.3H6.6a1.3 1.3 0 0 1-1.3-1.3V5.6h9.1zM8.55 8.85v3.9M11.15 8.85v3.9"
            strokeLinecap="round"
            strokeLinejoin="round"
            style={pathStyle}
          />
        </svg>
      )
    case 'modal-close':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
          viewBox="0 0 24 24"
          fill="none"
          width="24"
          height="24"
          className={className}
          style={style}
          onClick={onClick}
        >
          <path
            d="M22.8 1.2 1.2 22.8M1.2 1.2l21.6 21.6"
            strokeLinecap="round"
            strokeLinejoin="round"
            style={pathStyle}
          />
        </svg>
      )
    case 'tool-grouping':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
          viewBox="0 0 24 24"
          fill="none"
          width="24"
          height="24"
          className={className}
          style={style}
          onClick={onClick}
        >
          <path
            d="M22.8 1.2 1.2 22.8M1.2 1.2l21.6 21.6"
            strokeLinecap="round"
            strokeLinejoin="round"
            style={pathStyle}
          />
        </svg>
      )
    case 'tool-columns':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
          viewBox="0 0 24 24"
          fill="none"
          width="24"
          height="24"
          className={className}
          style={style}
          onClick={onClick}
        >
          <path
            d="M22.8 1.2 1.2 22.8M1.2 1.2l21.6 21.6"
            strokeLinecap="round"
            strokeLinejoin="round"
            style={pathStyle}
          />
        </svg>
      )
    case 'tool-filters':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
          viewBox="0 0 24 24"
          fill="none"
          width="24"
          height="24"
          className={className}
          style={style}
          onClick={onClick}
        >
          <path
            d="M22.8 1.2 1.2 22.8M1.2 1.2l21.6 21.6"
            strokeLinecap="round"
            strokeLinejoin="round"
            style={pathStyle}
          />
        </svg>
      )
    case 'tool-periods':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
          viewBox="0 0 24 24"
          fill="none"
          width="24"
          height="24"
          className={className}
          style={style}
          onClick={onClick}
        >
          <path
            d="M22.8 1.2 1.2 22.8M1.2 1.2l21.6 21.6"
            strokeLinecap="round"
            strokeLinejoin="round"
            style={pathStyle}
          />
        </svg>
      )
    case 'tool-settings':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
          viewBox="0 0 24 24"
          fill="none"
          width="24"
          height="24"
          className={className}
          style={style}
          onClick={onClick}
        >
          <path
            d="M12 13.964a1.964 1.964 0 1 0 0-3.928 1.964 1.964 0 0 0 0 3.928z"
            strokeLinecap="round"
            strokeLinejoin="round"
            style={pathStyle}
          />
          <path
            d="M16.844 13.964a1.08 1.08 0 0 0 .216 1.191l.039.04a1.308 1.308 0 0 1-.926 2.235 1.309 1.309 0 0 1-.926-.383l-.04-.04a1.08 1.08 0 0 0-1.191-.216 1.08 1.08 0 0 0-.655.989v.111a1.309 1.309 0 1 1-2.618 0v-.059a1.08 1.08 0 0 0-.707-.988 1.08 1.08 0 0 0-1.19.216l-.04.039a1.31 1.31 0 1 1-1.853-1.852l.04-.04a1.08 1.08 0 0 0 .216-1.191 1.08 1.08 0 0 0-.989-.655h-.11a1.31 1.31 0 1 1 0-2.618h.058a1.08 1.08 0 0 0 .988-.707 1.08 1.08 0 0 0-.216-1.19l-.039-.04a1.309 1.309 0 1 1 1.852-1.852l.04.039a1.08 1.08 0 0 0 1.191.216h.052a1.08 1.08 0 0 0 .655-.989v-.11a1.31 1.31 0 1 1 2.618 0v.058a1.08 1.08 0 0 0 .655.988 1.08 1.08 0 0 0 1.19-.216l.04-.039a1.308 1.308 0 0 1 2.236.926 1.309 1.309 0 0 1-.383.927l-.04.039a1.08 1.08 0 0 0-.216 1.191v.052a1.08 1.08 0 0 0 .989.655h.11a1.31 1.31 0 1 1 0 2.618h-.058a1.08 1.08 0 0 0-.988.655v0z"
            strokeLinecap="round"
            strokeLinejoin="round"
            style={pathStyle}
          />
        </svg>
      )
    case 'notification':
      return (
        <svg
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <mask id="path-1-inside-1_62_36803" fill="white">
            <path d="M32 16C32 32 32 32 16 32C7.16344 32 0 24.8366 0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16Z" />
          </mask>
          <path
            d="M32 16C32 32 32 32 16 32C7.16344 32 0 24.8366 0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16Z"
            fill="url(#paint0_linear_62_36803)"
          />
          <path
            d="M30 16C30 20.0489 29.997 22.9159 29.7622 25.0291C29.5258 27.1571 29.0901 28.0814 28.5858 28.5858C28.0814 29.0901 27.1571 29.5258 25.0291 29.7622C22.9159 29.997 20.0489 30 16 30V34C19.9511 34 23.0841 34.003 25.4709 33.7378C27.8429 33.4742 29.9186 32.9099 31.4142 31.4142C32.9099 29.9186 33.4742 27.8429 33.7378 25.4709C34.003 23.0841 34 19.9511 34 16H30ZM16 30C8.26801 30 2 23.732 2 16H-2C-2 25.9411 6.05887 34 16 34V30ZM2 16C2 8.26801 8.26801 2 16 2V-2C6.05887 -2 -2 6.05887 -2 16H2ZM16 2C23.732 2 30 8.26801 30 16H34C34 6.05887 25.9411 -2 16 -2V2Z"
            fill="white"
            mask="url(#path-1-inside-1_62_36803)"
          />

          <defs>
            <linearGradient
              id="paint0_linear_62_36803"
              x1="16"
              y1="0"
              x2="16"
              y2="32"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#FF6123" />
              <stop offset="1" stopColor="#FF9B25" />
            </linearGradient>
          </defs>
        </svg>
      )
    default:
      return null
  }
}

export type IconVariant =
  | 'main-menu-kpis'
  | 'main-menu-generic-report'
  | 'main-menu-headcount'
  | 'main-menu-scenario-versions'
  | 'main-menu-settings'
  | 'main-menu-analytics'
  | 'main-menu-planning'
  | 'main-menu-filter'
  | 'main-menu-calendar'
  | 'main-menu-versions'
  | 'main-menu-logout'
  | 'magnify-plus'
  | 'magnify-minus'
  | 'trashcan'
  | 'modal-close'
  | 'tool-grouping'
  | 'tool-columns'
  | 'tool-filters'
  | 'tool-periods'
  | 'tool-settings'
  | 'notification'
  | 'main-menu-business-optimization'
